// src/components/BackgroundSlider.js
import React, { useState, useEffect } from 'react';
import './BackgroundSlider.css';

export default function BackgroundSlider() {
    const desktopImages = [
        '/images/lokal1.jpg',
        '/images/lokal2.jpg',
        '/images/lokal3.jpg',
        '/images/lokal4.jpg',
    ];

    const mobileImages = [
        '/images/1.jpg',
        '/images/2.jpg',
        '/images/3.jpg',
        '/images/4.jpg',
    ];

    const [current, setCurrent] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // 🔹 Sprawdzamy zmianę rozmiaru ekranu
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const images = isMobile ? mobileImages : desktopImages;

    useEffect(() => {
        if (images.length > 1) {
            const interval = setInterval(() => {
                setCurrent(prev => (prev + 1) % images.length);
            }, 5000);
            return () => clearInterval(interval);
        }
    }, [images]);

    return (
        <div className="background-slider">
            {images.map((img, index) => (
                <img
                    key={index}
                    src={img}
                    alt={`tło ${index}`}
                    className={`bg-image ${index === current ? 'active' : ''}`}
                />
            ))}
        </div>
    );
}
